export default __webpack_public_path__ + "static/media/nphcda.4740d577.jpeg";